import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthHTTPService } from '../../../services/auth/auth-http.service';
import { ButtonModule } from 'primeng/button';
import { UserHttpService } from '../../../services';

@Component({
  selector: 'app-verify-account',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './verify-account.component.html',
  styleUrl: './verify-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerifyAccountComponent implements OnInit, OnDestroy {
  dataLoaded: WritableSignal<boolean> = signal(false);
  successVisible: WritableSignal<boolean> = signal(false);
  errorVisible: WritableSignal<boolean> = signal(false);

  verificationToken!: string | null;

  subscriptions$ = new Subscription();

  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  authHttpService = inject(AuthHTTPService);
  userService = inject(UserHttpService);

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((param) => {
      if (param.get('token') != null && param.get('token') != '') {
        this.verificationToken = param.get('token');
        //
        this.verifyEmail(this.verificationToken as string);
      } else {
        this.router.navigateByUrl('/');
      }
    });
  }
  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
  verifyEmail(token: string): void {
    if (typeof token != 'string' || token == null) {
      return;
    }

    const verifySubscription$ = this.userService
      .activateUser(token as string)
      .subscribe({
        next: (value) => {
          //
          this.dataLoaded.set(true);
          this.successVisible.set(true);
        },
        error: (err) => {
          this.dataLoaded.set(true);
          this.errorVisible.set(true);

        },
      });
    this.subscriptions$.add(verifySubscription$);
  }

}
